var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsaWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#EFF8F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3883_5904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.055 108.11C58.3796 108.11 44 93.7304 44 76.055C44 58.3796 58.3796 44 76.055 44C93.7304 44 108.11 58.3796 108.11 76.055C108.11 93.7304 93.7304 108.11 76.055 108.11ZM76.055 46.658C59.8414 46.658 46.658 59.8414 46.658 76.055C46.658 92.2686 59.8414 105.452 76.055 105.452C92.2686 105.452 105.452 92.2686 105.452 76.055C105.452 59.8414 92.2686 46.658 76.055 46.658Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2734 78.2134H75.829C75.0848 78.2134 74.5 77.6286 74.5 76.8844V57.829C74.5 57.0848 75.0848 56.5 75.829 56.5C76.5732 56.5 77.158 57.0848 77.158 57.829V75.5554H90.2734C91.0177 75.5554 91.6024 76.1401 91.6024 76.8844C91.6024 77.6286 91.0177 78.2134 90.2734 78.2134Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2734 79.7134H75.829C74.2563 79.7134 73 78.457 73 76.8844V57.829C73 56.2563 74.2563 55 75.829 55C77.4016 55 78.658 56.2563 78.658 57.829V74.0554H90.2734C91.8461 74.0554 93.1024 75.3117 93.1024 76.8844C93.1024 78.457 91.8461 79.7134 90.2734 79.7134ZM90.2734 75.5554C91.0177 75.5554 91.6024 76.1401 91.6024 76.8844C91.6024 77.6286 91.0177 78.2134 90.2734 78.2134H75.829C75.0848 78.2134 74.5 77.6286 74.5 76.8844V57.829C74.5 57.0848 75.0848 56.5 75.829 56.5C76.5732 56.5 77.158 57.0848 77.158 57.829V75.5554H90.2734Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0555 51.4954C75.3113 51.4954 74.7266 50.9107 74.7266 50.1665V45.329C74.7266 44.5848 75.3113 44 76.0555 44C76.7998 44 77.3845 44.5848 77.3845 45.329V50.1665C77.3845 50.9107 76.7998 51.4954 76.0555 51.4954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.78 77.3845H101.942C101.198 77.3845 100.613 76.7998 100.613 76.0555C100.613 75.3113 101.198 74.7266 101.942 74.7266H106.78C107.524 74.7266 108.109 75.3113 108.109 76.0555C108.109 76.7998 107.524 77.3845 106.78 77.3845Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0555 108.109C75.3113 108.109 74.7266 107.524 74.7266 106.78V101.942C74.7266 101.198 75.3113 100.613 76.0555 100.613C76.7998 100.613 77.3845 101.198 77.3845 101.942V106.78C77.3845 107.524 76.7998 108.109 76.0555 108.109Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1665 77.3845H45.329C44.5848 77.3845 44 76.7998 44 76.0555C44 75.3113 44.5848 74.7266 45.329 74.7266H50.1665C50.9107 74.7266 51.4954 75.3113 51.4954 76.0555C51.4954 76.7998 50.9107 77.3845 50.1665 77.3845Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3883_5904"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.11,
    height: 64.11,
    fill: "white",
    transform: "translate(44 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsaWatch);
export default __webpack_public_path__ + "static/media/RsaWatch.79101abf.svg";
export { ForwardRef as ReactComponent };